import { inject, isDevMode } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { FrontendLogger } from '@biz-nest/core-client';
import { AuthService } from '@front-shared-lib';

export const authGuard: CanActivateFn = () => {
  const auth = inject(AuthService);
  const router = inject(Router);

  if (isDevMode()) {
    FrontendLogger
      .debug(`authGuard:: canActivate:
      isDevMode`);
    // return true;
  }
  if (auth.isLoggedIn) {
    FrontendLogger
      .debug(`AuthGuard:: canActivate:
      user has been loggedIn, return true`);

    return true;
  }
  FrontendLogger
    .debug(`AuthGuard:: canActivate:
    user has no permision access route Guard
    status is,
      ${auth.isLoggedIn}`);
  // this.auth.auth.redirectUrl = decodeURIComponent(url);
  router.navigate(['login']);

  return false;
};
